export const BaseUrl = "https://carvaanofficial.com/";

export const accessToken = localStorage.getItem("accessToken");
